var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('g-tag',{attrs:{"theme":_vm.color}},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }